<template>
  <div>
    <div class="row">
      <div class="col-md-12 text-left">
        <button type="button" :disabled="loading" @click="refreshNodes()" class="btn btn-primary">
          <div class="loader" v-if="loading" style="width: 15px;height: 15px; margin: 0 !important;"></div>
           <span v-else>Refresh</span>
        </button>
        <button type="button" @click="loadRackModal()" class="btn btn-primary">Add new node</button>
      </div>
    </div>
    <table id="node" class="table table-striped">
    <thead>
    <tr>
      <th scope="col">ID</th>
      <th scope="col">Virt</th>
      <th scope="col">Name</th>
      <th scope="col">IP</th>
      <th scope="col">Country</th>
      <th scope="col">City</th>
      <th scope="col">Allocated memory (GB)</th>
      <th scope="col">Free disk (GB)</th>
      <th scope="col">Virtual Servers</th>
      <th scope="col">Free Ips</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(row, index) in nodes" :key="index">
      <th scope="row">{{Number(row.id) || ''}}</th>
      <td>{{ row.virt || '' }}</td>
      <td>{{ row.name || '' }}</td>
      <td>{{row.ip || ''}}</td>
      <td>{{row.country || ''}}</td>
      <td>{{row.city || ''}}</td>
      <td>
        {{ row.allocated_memory }}
<!--        <div class="progress"  style="height: 20px;">-->
<!--        <div :class="{'progress-bar': true, 'bg-success': true}" :style="{'width': ((Number(row.allocatedmemory) /Number(row.memorylimit))*100).toFixed(1)+'%'}" role="progressbar" aria-valuemin="0" aria-valuemax="100">-->
<!--          {{ ((Number(row.allocatedmemory)/Number(row.memorylimit))*100).toFixed(1) }} %-->
<!--        </div>-->
<!--      </div>-->
      </td>
      <td>
<!--        {{ (Number(row.freedisk)/(1024 * 1024)).toFixed(1) }} GB-->
        {{row.free_disk}}
      </td>
      <td>{{row.virtualservers || ''}}</td>
      <td>{{row.freeips || ''}}</td>
      <td>
        <button @click="openModal(row)" class="btn-sm btn btn-primary mr-2"><i class="fa fa-pencil"></i></button>
        <button :disabled="loading" @click="deleteNode(row)"  class="btn-sm btn btn-danger mt-1"><i class="fa fa-trash"></i></button>
      </td>
    </tr>
    </tbody>
  </table>
    <div class="modal_body">
      <div class="modal" tabindex="-1" role="dialog" id="nodeModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">
                Update Node Info
              </h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="row">
                  <label class="col-sm-2 col-md-2 col-lg-2 text-center col-form-label">Node ID
                    <strong class="text-danger">*</strong>
                  </label>
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <div class="form-group">
                      <input type="text" class="form-control" disabled v-model="nodeInfo.id" required >
                    </div>
                  </div>
                  <label class="col-sm-2 col-md-2 col-lg-2 text-center col-form-label">Node Fname
                    <strong class="text-danger">*</strong>
                  </label>
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <div class="form-group">
                      <input type="text" class="form-control" v-model="nodeInfo.nodeFname" required >
                    </div>
                  </div>
                  <label class="col-sm-2 col-md-2 col-lg-2 text-center col-form-label">Node IP
                    <strong class="text-danger">*</strong>
                  </label>
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <div class="form-group">
                      <input type="text" class="form-control" v-model="nodeInfo.nodeIp" required >
                    </div>
                  </div>
                  <label class="col-sm-2 col-md-2 col-lg-2 text-center col-form-label">Node Name
                    <strong class="text-danger">*</strong>
                  </label>
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <div class="form-group">
                      <input type="text" class="form-control" v-model="nodeInfo.nodeName" required >
                    </div>
                  </div>

                </div>
<!--                <div class="row">-->
<!--                  <div class="col-sm-12 col-md-12 col-lg-12 text-right">-->
<!--                    <button :disabled="loading" type="submit" class="btn btn-primary ">Save </button>-->
<!--                  </div>-->

<!--                </div>-->

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click="updateNodeInfo()" :disabled="loading" type="submit" class="btn btn-primary ">Save </button>

            </div>
          </div>
        </div>
      </div>

    </div>



  </div>

</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "nodes",
  components: {
    racksModal: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/Dashboard/racksModal"),
  },
  computed: {
    nodes(){
      let array= this.allNodes.filter(el => el.virt)
      array.map(el => {
        if(Number(el.freedisk)){
          el.free_disk=Math.floor(Number(el.freedisk)/(1024 * 1024))
        }
        else{
          el.free_disk=0
        }
        if(Number(el.allocatedmemory)){
          el.allocated_memory=Math.floor((Number(el.allocatedmemory)/(1024 * 1024)))
        }
        else{
          el.allocated_memory=0
        }
      })
      return array
    }
  },
  data(){
    return {
      allNodes: [],
      nodeInfo: {},
      loading: false
    }
  },
   mounted() {
     this.getAllNodes()

  },
  methods: {
    async updateNodeInfo(){
      try {
        let id=this.nodeInfo.id
        delete this.nodeInfo.id
        this.loading=true
        await db.collection('nodes').doc(id).set(this.nodeInfo)
        this.nodeInfo.id=id
        this.loading=false;
        this.nodeInfo={}
        swal({
          title: "Success",
          text: "Node info has been created successfully updated!",
          type: "success",
        });
        $("#nodeModal").modal("hide");

      }
      catch(err){
        this.loading=false;
        this.nodeInfo={}

        swal({
          title: "Error",
          text: "Error while updating node info " ,
          type: "error",
        });
        $("#nodeModal").modal("hide");

      }

    },
    async deleteNode(row){
      try{
        swal({
          title: "Delete Node",
          text: "Are you sure you want to delete node?",
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then(async result =>  {
          if(result.value){

            this.loading=true
            await db.collection('nodes').doc(row.id).delete()

            await this.getAllNodes();
            this.loading=false
            swal({
              title: "Success",
              text: "You have successfully deleted node  " ,
              type: "success",
            });
          }
        }).catch((err)=>{
          console.log('error', err)
          this.loading=false
          swal({
            title: "Error",
            text: "Error while deleting nodes " ,
            type: "error",
          });
        });
      }
      catch(err){
        this.loading=false
        swal({
          title: "Error",
          text: "Error while un-assigning nodes " ,
          type: "error",
        });
        $('#nodesModal').modal('hide');
      }

    },
    loadRackModal(){
      this.$parent.$refs.racks.load('node')
    },
    openModal(row){
      this.nodeInfo={}
      this.nodeInfo=row

      $("#nodeModal").modal("show");

    },
    renderDatatable() {
      setTimeout(function () {
        $(`#node`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: true,
          "bInfo" : false,
          "ordering": true,
          'columnDefs': [ {
            'targets': [-1], /* column index */
            'orderable': false, /* true or false */
          }]

        });
      }, 0)
    },
    async refreshNodes(){
      try{
        this.loading=true
        await this.$http.post('/solus-vm/get_node_details', {
          grant_type: 'token',
          nodeId: 19
        })
        await this.getAllNodes()
        swal({
          title: "Success",
          text: "You have successfully refreshed nodes' data",
          type: "success",
        });
      }catch(e){
        console.log(e.toString())
        swal({
          title: "Error",
          text: "Something went wrong while refreshing node data",
          type: "error",
        });
      }
      finally {
        this.loading=false
      }
    },
    async getAllNodes(){
      console.log('nodes func called')
      try{
        this.loading=true
        let nodesResp=await  db.collection('nodes').get()
        this.allNodes= []
        nodesResp.forEach( el => {
          this.allNodes.push({id:el.id, ...el.data()})
        })
        console.log(this.allNodes)
        await this.renderDatatable()
      }catch(e){
        console.log('error', e.toString())
      }
      finally {
        this.loading=false
      }
    },
  }
}
</script>

<style scoped>

</style>
